import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card shadow-sm mb-4" }
const _hoisted_2 = { class: "card-content p-2" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["href", "onClick"]
const _hoisted_6 = { class: "row visit-card" }
const _hoisted_7 = { class: "col-10" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "border-end time-slot float-start pt-3 me-2" }
const _hoisted_10 = { class: "text-secondary fw-bold" }
const _hoisted_11 = { class: "text-primary fw-bold" }
const _hoisted_12 = { class: "mobile-visit-card overflow-hidden" }
const _hoisted_13 = { class: "fw-bold text-secondary" }
const _hoisted_14 = { class: "text-primary" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { key: 2 }
const _hoisted_18 = { key: 3 }
const _hoisted_19 = { key: 4 }
const _hoisted_20 = { key: 5 }
const _hoisted_21 = {
  key: 0,
  class: "mt-1"
}
const _hoisted_22 = { class: "text-secondary" }
const _hoisted_23 = {
  key: 1,
  class: "text-center pt-3"
}
const _hoisted_24 = {
  key: 1,
  class: "loading-card-area"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pagination = _resolveComponent("pagination")!
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "card-header text-white bg-secondary fw-bold" }, "Canceled Visits", -1)),
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.visit_loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (Object.keys(_ctx.props.canceled_visits).length)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.props.canceled_visits.slice(_ctx.page_start,_ctx.page_end), (visit) => {
                    return (_openBlock(), _createElementBlock("a", {
                      href: '/#/visit/' + visit.id,
                      key: visit.id,
                      class: "col-12 d-block visit-card-anchor",
                      onClick: ($event: any) => (_ctx.router.push({name:'visit',params:{visit_id:visit.id}}))
                    }, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("img", {
                            src: visit.scenario.patient_image.location,
                            class: "rounded-circle float-start me-2",
                            width: "75"
                          }, null, 8, _hoisted_8),
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.moment(visit.utc_time || visit.local_time).format('MM/DD/YY')), 1),
                            _cache[0] || (_cache[0] = _createElementVNode("hr", { class: "my-1" }, null, -1)),
                            _createElementVNode("span", _hoisted_11, [
                              _createTextVNode(_toDisplayString(_ctx.moment(visit.utc_time || visit.local_time).format('h:mm')), 1),
                              _createElementVNode("sup", null, _toDisplayString(_ctx.moment(visit.utc_time || visit.local_time).format('a')), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, _toDisplayString(visit.scenario.patient_name), 1),
                            _createElementVNode("div", null, [
                              _createElementVNode("span", null, _toDisplayString(visit.scenario.title), 1),
                              _createElementVNode("div", _hoisted_14, [
                                (visit.no_show)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, "No Show"))
                                  : (visit.learner_technical_issue)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, "Learner Technical Issue"))
                                    : (visit.is_canceled && !visit.is_confirmed && !visit.canceled_by)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_17, "System Cancellation"))
                                      : (visit.is_canceled && visit.is_sp_cancellation)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_18, "SP Cancellation"))
                                        : (visit.is_canceled && !visit.is_sp_cancellation)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_19, "Learner Cancellation"))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_20, "Cancellation"))
                              ])
                            ]),
                            (_ctx.is_admin)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                  _createElementVNode("small", _hoisted_22, _toDisplayString(visit.partner.slug), 1),
                                  _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
                                  _cache[2] || (_cache[2] = _createElementVNode("small", { class: "text-secondary" }, "Standardized Patient", -1)),
                                  _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
                                  _createElementVNode("small", null, _toDisplayString(visit.standardized_patient.name) + " (" + _toDisplayString(visit.standardized_patient.email) + ")", 1),
                                  _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
                                  _cache[5] || (_cache[5] = _createElementVNode("small", { class: "text-secondary" }, "Participant", -1)),
                                  _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
                                  _createElementVNode("small", null, _toDisplayString(visit.learner.name) + " (" + _toDisplayString(visit.learner.email) + ")", 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "col-2 d-flex flex-column justify-content-center" }, [
                          _createElementVNode("h3", { class: "text-center" }, [
                            _createElementVNode("i", { class: "far fa-window-close text-primary" })
                          ])
                        ], -1))
                      ]),
                      _cache[8] || (_cache[8] = _createElementVNode("hr", { class: "w-75" }, null, -1))
                    ], 8, _hoisted_5))
                  }), 128)),
                  (Object.keys(_ctx.props.canceled_visits).length > 10)
                    ? (_openBlock(), _createBlock(_component_pagination, {
                        key: 0,
                        items: _ctx.props.canceled_visits,
                        page_start: _ctx.page_start,
                        page_end: _ctx.page_end,
                        onNextPage: _ctx.nextPage,
                        onPreviousPage: _ctx.previousPage,
                        label: 'Visits'
                      }, null, 8, ["items", "page_start", "page_end", "onNextPage", "onPreviousPage"]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_23, "No Canceled Visits"))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_24, [
            _createVNode(_component_loading, {
              active: _ctx.visit_loading,
              "is-full-page": false
            }, null, 8, ["active"])
          ]))
    ])
  ]))
}